<template>
  <div class="activity-detail-main">
    <el-tabs
      v-model="activeName"
      @tab-click="tabCheckClick"
      class="activity-detail-tabs"
    >
      <el-tab-pane label="活动统计" name="first">
        <div class="active-main">
          <div class="sub-title">数据概览</div>
          <div class="data-overview-main">
            <div class="data-overview-item">
              <div class="chart-title">连续达成天数对应用户数</div>
              <div class="chart-label">
                <div class="chart-label-left">连续天数</div>
                <div class="chart-label-right">
                  <div class="illustration"></div>
                  <span>用户数</span>
                </div>
              </div>
              <div ref="userEcharts" style="width: 100%; height: 300px"></div>
            </div>
            <div class="data-overview-item data-brief">
              <div class="chart-title" style="margin-bottom: 20px">
                数据简报
              </div>
              <img class="brief-img" src="@/assets/images/pic_update@2x.png" />
              <div class="brief-container">
                <div class="brief-item">
                  <span class="brief-label">总报名人数</span>
                  <span class="brief-unit">
                    <span class="brief-value"
                      >{{ briefData?.regNum || 0 }}
                    </span>
                    人</span
                  >
                </div>
                <div class="brief-item">
                  <span class="brief-label">平均连续天数</span>
                  <span class="brief-unit"
                    ><span class="brief-value" v-if="briefData?.avgValidDays"
                      >{{ briefData?.avgValidDays.toFixed(2) }}
                    </span>
                    <span class="brief-value" v-else>0</span>
                    天</span
                  >
                </div>
                <div class="brief-item">
                  <span class="brief-label">总达成人数</span>
                  <span class="brief-unit"
                    ><span class="brief-value">{{
                      briefData?.achieveNum || 0
                    }}</span>
                    人</span
                  >
                </div>
                <div class="brief-item">
                  <span class="brief-label">达成率</span>
                  <span class="brief-unit"
                    ><span class="brief-value">{{
                      ((briefData?.achieveRate ?? 0) * 100).toFixed(2)
                    }}</span>

                    %</span
                  >
                </div>
                <div class="brief-item">
                  <span class="brief-label">挑战中人数</span>
                  <span class="brief-unit"
                    ><span class="brief-value">{{
                      briefData?.progressNum || 0
                    }}</span>
                    人</span
                  >
                </div>
                <div class="brief-item">
                  <span class="brief-label">失败人数</span>
                  <span class="brief-unit"
                    ><span class="brief-value">{{
                      briefData?.failNum || 0
                    }}</span>
                    人</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="活动用户" name="second">
        <activeUser :promotion="promotion"></activeUser>
      </el-tab-pane>
      <el-tab-pane label="活动配置" name="third">
        <div class="active-set">
          <creatandEdit :isEdit="true" :promotion="promotion"></creatandEdit>
        </div>
      </el-tab-pane>
      <el-tab-pane label="活动设备" name="four">
        <active-device :promotion="promotion"></active-device>
      </el-tab-pane>
    </el-tabs>
    <div class="day-data" v-if="activeName === 'first'">
      <div class="sub-title">每日数据</div>
      <div class="day-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column align="center" prop="day" label="活动天数">
            <template slot-scope="scope">
              第{{ scope.row?.day || 0 }}天
            </template>
          </el-table-column>
          <el-table-column align="center" prop="regNum" label="报名人数">
            <template slot-scope="scope">
              {{ scope.row?.regNum }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="regTotal" label="总报名人数">
            <template slot-scope="scope">
              {{ scope.row?.regTotal }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="progressNum" label="挑战中人数">
            <template slot-scope="scope">
              {{ scope.row?.progressNum }}
            </template></el-table-column
          >
          <el-table-column
            align="center"
            prop="clockInNum"
            label="当日挑战成功人数"
          >
            <template slot-scope="scope">
              {{ scope.row?.clockInNum }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="failNum"
            label="当日挑战失败人数"
          >
            <template slot-scope="scope">
              {{ scope.row?.failNum }}
            </template></el-table-column
          >
          <el-table-column align="center" prop="achieveNum" label="达成人数">
            <template slot-scope="scope">
              {{ scope.row?.achieveNum }}
            </template></el-table-column
          >
          <el-table-column
            align="center"
            prop="achieveTotal"
            label="总达成人数"
          >
            <template slot-scope="scope">
              {{ scope.row?.achieveTotal }}
            </template></el-table-column
          >
        </el-table>
        <div class="page-pagination">
          <el-pagination
            layout="->,sizes,total,prev, pager, next, jumper"
            @current-change="currentChangefn"
            @size-change="handleSizeChange"
            :page-sizes="[5, 10, 20, 50, 100]"
            :total="total"
            :page-size="size"
            :current-page="page"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import creatandEdit from "./components/creatandEdit.vue";
import activeUser from "./components/activeUser.vue";
import ActiveDevice from "./components/activeDevice.vue";
export default {
  components: {
    creatandEdit,
    activeUser,
    ActiveDevice,
  },
  data() {
    return {
      activeName: "first",
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      activeId: "",
      briefData: {},
      statisticData: [],
      targetDays: "",
      promotion: {},
    };
  },
  async created() {
    console.log("this.$route.query", this.$route.query);
    const id = this.$route.query.id;
    const targetDays = this.$route.query.targetDays;
    if (id) {
      this.activeId = id;
    }
    this.targetDays = targetDays;
    await this.getActiveInfo();
    this.getStatisticData();
    this.getBriefData();
    this.getDaysData();
  },
  mounted() {},
  methods: {
    async getActiveInfo() {
      let res = await this.$get("/promotion/get", { id: this.activeId });
      if (res.data?.code === 1000) {
        this.promotion = res.data?.data;
      } else {
        this.$mesage.error(res.data?.msg);
      }
    },
    tabCheckClick(tab, event) {
      // console.log(tab, event);
    },
    generateArray() {
      let result = [];
      let count = 50;
      let days = 50;
      let n = 0;

      for (let i = 0; i < n; i++) {
        result.push({
          count: count, // count 递减
          days: days, // days 递增
        });
        count--;
        days++;
      }
      return result;
    },
    getStatisticData() {
      this.$get("/promotion/days/statistics", { id: this.activeId }).then(
        (res) => {
          if (res.data && res.data?.code === 1000) {
            // this.statisticData = res.data?.data || [];
            const dataList = res.data?.data;
            const targetDays = Number(this.targetDays);

            if (dataList && dataList.length > 0) {
              const daysRange = Array.from(
                { length: targetDays + 1 },
                (_, i) => i
              );
              const processedData = dataList.map((item) => {
                if (!item.hasOwnProperty("days")) {
                  return { ...item, days: 0 }; // 如果没有 days，默认补充 days: 0
                }
                return item;
              });
              // 用来处理数据
              const result = daysRange.map((day) => {
                const existing = processedData.find(
                  (item) => item.days === day
                );
                if (existing) {
                  return existing;
                } else {
                  return { days: day, count: 0 };
                }
              });
              // console.log("result", result);
              this.statisticData = result;
            }
            this.initChart();
          }
        }
      );
    },
    getBriefData() {
      //简报数据
      this.$get("/promotion/data/briefing", { id: this.activeId }).then(
        (res) => {
          if (res.data && res.data?.code === 1000) {
            this.briefData = res.data?.data;
          } else {
            // this.$message.error(res.data?.msg);
          }
        }
      );
    },
    getDaysData() {
      this.$get("/promotion/daily/data", {
        page: this.page,
        size: this.size,
        id: this.activeId,
      }).then((res) => {
        if (res.data && res.data?.code === 1000) {
          this.tableData = res.data?.data?.list || [];
          this.total = res.data?.data?.count;
        } else {
          // this.$message.error(res.data?.msg);
        }
      });
    },
    currentChangefn(index) {
      this.page = index;
      this.getDaysData();
    },
    handleSizeChange(val) {
      this.size = val;
      this.getDaysData();
    },
    initChart() {
      const chart = echarts.init(this.$refs.userEcharts);

      let Ydata = []; // Y轴数据
      let Xdata = []; // X轴数据
      // console.log("initChart", this.statisticData);

      let sdata = this.statisticData.map((v) => ({ ...v, days: v.days ?? 0 }));
      sdata =
        sdata.length > 0
          ? sdata
          : Array(+this.targetDays + 1)
              .fill(0)
              .map((v, i) => ({ days: i, count: 0 }));
      sdata
        .sort((a, b) => a.days - b.days)
        .forEach((item) => {
          Ydata.push(`${item.days}天`);
          Xdata.push(item.count);
        });

      let dataZoomShow = false;
      if (Ydata.length > 7) dataZoomShow = true;

      const option = {
        grid: {
          top: 20,
          left: 40,
          right: 20,
          bottom: 30,
          containLabel: false,
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "filter: blur(10px);", // 设置背景透明
          extraCssText: "backdrop-filter: blur(6px);",
          borderColor: "transparent", // 去掉边框颜色
          borderWidth: 0, // 去掉边框
          padding: [0, 0],
          formatter: function (params) {
            const name = params.name;
            const value = params.value;

            return `
            <div style="color: #1D2129; font-size: 14px;width: 180px;border: 0px #fff solid;border-radius: 6px;padding:8px;">
             <div style="padding-left:8px;margin-bottom:6px;">${name}</div>
             <div style="display:flex;justify-content: space-between;background-color: #fff;padding:6px 8px;box-sizing:border-box;border-radius:4px">
              <div style="display:flex;align-items:center"><div style="width:10px;height:10px;background-color: #165DFF;border-radius:50%;margin-right:8px"></div><span>用户数</span></div>
              <div>${value}</div>
             </div>
            </div>
            `;
          },
        },
        xAxis: {
          type: "value", // 修改为 'value' 类型，表示数值轴
          axisLabel: {
            formatter: function (value) {
              return Number.isInteger(value) ? value : ""; // 只有是整数时才显示，其他情况返回空字符串
            },
          },
        },
        // 新增 dataZoom 配置
        dataZoom: [
          {
            type: "slider",
            show: dataZoomShow, // 隐藏或显示（true）组件
            showDataShadow: false,
            borderRadius: "8px !important",
            backgroundColor: "#F2F3F5", // 组件的背景颜色
            fillerColor: "#165DFF", // 选中范围的填充颜色
            borderColor: "transparent", // 边框颜色
            showDetail: false, // 是否显示detail，即拖拽时显示详细数值信息
            startValue: 0, // 数据窗口范围的起始数值
            endValue: 6, // 数据窗口范围的结束数值
            yAxisIndex: [0, 1], // 控制哪个轴，如果是 number 表示控制一个轴，如果是 Array 表示控制多个轴
            filterMode: "empty",
            width: 5, // 滚动条宽度
            height: "80%", // 滚动条显示位置
            right: 3, // 距离右边
            handleSize: 0, // 控制手柄的尺寸
            zoomLock: true, // 是否锁定选择区域（或叫做数据窗口）的大小
            top: "middle", // 设置顶部位置
            handleStyle: {
              cursor: "default", // 强制鼠标指针为默认样式
              borderColor: "transparent", // 手柄边框颜色
              borderWidth: 0,
              borderRadius: "8px !important",
              color: "#FFF", // 手柄填充颜色
              opacity: 1, // 默认透明度
              handleIcon: "none", // 隐藏十字线图标
            },
            brushSelect: false, // 禁用刷选缩放
            moveOnMouseClick: true, // 鼠标点击时是否能移动
            zoomOnMouseWheel: false, // 鼠标滚轮是否触发缩放
            moveOnMouseMove: true, // 鼠标移动是否触发平移
            moveOnMouseWheel: true, // 鼠标滚轮是否触发平移
            inside: {
              // yAxisIndex: [0, 1], // 控制哪个轴
              // zoomOnMouseWheel: false, // 滚轮是否触发缩放
              moveOnMouseMove: true, // 鼠标移动是否触发平移
              moveOnMouseWheel: true, // 鼠标滚轮是否触发平移
            },
          },
        ],
        yAxis: {
          type: "category", // 修改为 'category' 类型，表示类别轴
          data: Ydata, // 类别数据
          axisTick: {
            show: false, // 去除刻度线
          },
          axisLine: {
            lineStyle: {
              color: "#dcdcdc", // 设置 Y 轴颜色为辅助线颜色（灰色）
            },
          },
          axisLabel: {
            color: "#4E5969", // 设置 Y 轴刻度线字体颜色为灰色（可以根据需要修改）
          },
          // min: 0, // 设置 Y 轴的最小值为 0
          inverse: true,
        },
        series: [
          {
            data: Xdata, // 用户数数据
            type: "bar",
            itemStyle: {
              color: "#4086FF",
              borderRadius: [4, 4, 4, 4], // 设置圆角，四个角都为圆角
            },
            barWidth: "8px", // 调整条形的宽度
          },
        ],
      };

      chart.setOption(option);
      window.addEventListener("resize", function () {
        chart.resize();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.activity-detail-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.data-overview-main {
  display: flex;
  justify-content: space-between;
  // margin-bottom: 18px;
}
.activity-detail-tabs {
  background-color: #fff;
  padding: 10px 20px 20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.active-main {
  padding-top: 5px;
  margin: 5px 0 16px;
}
.sub-title {
  font-weight: 500;
  font-size: 16px;
  color: #1d2129;
  margin-bottom: 16px;
}
.data-overview-item {
  display: flex;
  width: calc(50% - 10px);
  flex-direction: column;
  border-radius: 4px;
  padding: 16px 20px 0;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f4f9ff 0%, #ffffff 100%);
  .chart-title {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    margin-bottom: 12px;
  }
  .chart-label {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    .chart-label-left {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
    .chart-label-right {
      font-weight: 400;
      font-size: 12px;
      color: #4e5969;
      display: flex;
      align-items: center;
      .illustration {
        width: 10px;
        height: 10px;
        background: #165dff;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }
}
//.data-brief {
// background-color: pink;
// position: relative;
//}
.day-data {
  border-radius: 4px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 18px;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 0px;
}
::v-deep .el-tabs__item {
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
}
::v-deep .el-tabs__item.is-active {
  font-weight: 600;
  font-size: 14px;
  color: #165dff;
}
::v-deep .el-tabs__active-bar {
  background-color: #165dff;
}
.active-set {
  display: flex;
  width: 100%;
  height: 100%;
}
.brief-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 52px 16px;
  position: relative;
  flex-grow: 1;
}

.brief-item {
  flex: 1 1 40%;
  text-align: center;
}

.brief-label {
  display: block;
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  line-height: 22px;
  margin-bottom: 8px;
}
.brief-unit {
  font-weight: 500;
  font-size: 14px;
  color: #1d2129;
  line-height: 22px;
}
.brief-value {
  font-size: 18px;
  font-weight: bold;
  color: #2f77de;
}
.brief-img {
  width: 193px;
  height: auto;
  position: absolute;
  bottom: 20px;
  right: 25px;
}
.page-pagination {
  padding: 20px 0;
}
</style>
